/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDirect3DfeatureLevel: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetDirect3DfeatureLevelParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetDirect3DfeatureLevelReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDirect3DfeatureLevel',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGPUInformation: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetGPUInformationParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetGPUInformationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetGPUInformation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsECCModeSupported: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.IsECCModeSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'IsECCModeSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetECCModeStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetECCModeStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetECCModeStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetECCModeStatus: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetECCModeStatusParameters,
    Types.Nvapp.Nvcpldisplayplugin.SetECCModeStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetECCModeStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSuperResolutionInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetSuperResolutionInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSuperResolutionInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSuperResolutionCurrentStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetSuperResolutionCurrentStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSuperResolutionCurrentStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetSuperResolutionValue: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetSuperResolutionValueParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetSuperResolutionValue',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSuperResolutionGpuUtilization: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetSuperResolutionGpuUtilizationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSuperResolutionGpuUtilization',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetSuperResolutionGpuUtilization: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetSuperResolutionGpuUtilizationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetSuperResolutionGpuUtilization',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSuperResolutionIndicatorStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetSuperResolutionIndicatorStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSuperResolutionIndicatorStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRTXVideoFlags: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetRTXVideoFlagsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetRTXVideoFlags',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetRTXVSRFlags: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetRTXVSRFlagsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetRTXVSRFlags',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetRTXHDRFlags: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetRTXHDRFlagsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetRTXHDRFlags',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetSuperResolutionIndicatorStatus: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetSuperResolutionIndicatorStatusParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetSuperResolutionIndicatorStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHDRIndicatorStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetHDRIndicatorStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetHDRIndicatorStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHDRIndicatorStatus: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetHDRIndicatorStatusParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetHDRIndicatorStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDisableVSROnGameLaunchStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetDisableVSROnGameLaunchStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDisableVSROnGameLaunchStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDisableVSROnGameLaunchStatus: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDisableVSROnGameLaunchStatusParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDisableVSROnGameLaunchStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDisableHDROnGameLaunchStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetDisableHDROnGameLaunchStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDisableHDROnGameLaunchStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDisableHDROnGameLaunchStatus: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDisableHDROnGameLaunchStatusParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDisableHDROnGameLaunchStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreDefaultVideoSettings: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'RestoreDefaultVideoSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHDRInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetHDRInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetHDRInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHDRCurrentStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetHDRCurrentStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetHDRCurrentStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHDRValue: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetHDRValueParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetHDRValue',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHDRInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetHDRInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetHDRInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterDisplayChangeNotification: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'RegisterDisplayChangeNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuCount: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetGpuCountReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetGpuCount',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LaunchApplication: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.LaunchApplicationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'LaunchApplication',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsControlPanelClientInstalled: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.IsControlPanelClientInstalledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'IsControlPanelClientInstalled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDisplaysState: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetDisplaysStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDisplaysState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDisplaysState: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDisplaysStateParameters,
    Types.Nvapp.Nvcpldisplayplugin.SetDisplaysStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDisplaysState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDebugModeStatus: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetDebugModeStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDebugModeStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDebugModeStatus: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDebugModeStatusParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDebugModeStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsDebugModeSupported: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.IsDebugModeSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'IsDebugModeSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDisplayResolutionList: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetDisplayResolutionListParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetDisplayResolutionListReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDisplayResolutionList',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuAndDisplayInformation: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetGpuAndDisplayInformationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetGpuAndDisplayInformation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuActivityInformation: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetGpuActivityInformationParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetGpuActivityInformationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetGpuActivityInformation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIGpuAndDisplayInformation: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetIGpuAndDisplayInformationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetIGpuAndDisplayInformation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuAndDisplaysPhysicalInformation: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetGpuAndDisplaysPhysicalInformationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetGpuAndDisplaysPhysicalInformation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreDisplaySettings: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.RestoreDisplaySettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'RestoreDisplaySettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetResolution: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetResolutionParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetResolution',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetRotation: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetRotationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetRotation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RevertState: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'RevertState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CancelState: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'CancelState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CommitState: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'CommitState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IdentifyDisplays: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.IdentifyDisplaysParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'IdentifyDisplays',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSystemCapabilities: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetSystemCapabilitiesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSystemCapabilities',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGlobalGsyncState: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetGlobalGsyncStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetGlobalGsyncState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetGlobalGsyncState: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetGlobalGsyncStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetGlobalGsyncState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGsyncIndicator: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetGsyncIndicatorReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetGsyncIndicator',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetGsyncIndicator: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetGsyncIndicatorParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetGsyncIndicator',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreGlobalGsyncState: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.RestoreGlobalGsyncStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'RestoreGlobalGsyncState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDisplayGsyncState: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetDisplayGsyncStateParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetDisplayGsyncStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDisplayGsyncState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDisplayGsyncState: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDisplayGsyncStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDisplayGsyncState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDisplayPulsarInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDisplayPulsarInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDisplayPulsarInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDisplayAmbientAdaptiveInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetDisplayAmbientAdaptiveInfoParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetDisplayAmbientAdaptiveInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDisplayAmbientAdaptiveInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDisplayAmbientAdaptiveBrightnessInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDisplayAmbientAdaptiveBrightnessInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDisplayAmbientAdaptiveBrightnessInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDisplayAmbientAdaptiveColorInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDisplayAmbientAdaptiveColorInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDisplayAmbientAdaptiveColorInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIsColorSettingsOsControlled: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetIsColorSettingsOsControlledParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetIsColorSettingsOsControlledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetIsColorSettingsOsControlled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetIsColorSettingsOsControlled: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetIsColorSettingsOsControlledParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetIsColorSettingsOsControlled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetColorEnhancementInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetColorEnhancementInfoParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetColorEnhancementInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetColorEnhancementInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAdvancedColorCombinationInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetAdvancedColorCombinationInfoParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetAdvancedColorCombinationInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetAdvancedColorCombinationInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAdvancedColorCombinationInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetAdvancedColorCombinationInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetAdvancedColorCombinationInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDynamicRange: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDynamicRangeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDynamicRange',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetOutputColorFormat: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetOutputColorFormatParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetOutputColorFormat',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDesktopColorDepth: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDesktopColorDepthParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDesktopColorDepth',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetOutputColorDepth: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetOutputColorDepthParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetOutputColorDepth',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDesktopColorCombinationInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetDesktopColorCombinationInfoParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetDesktopColorCombinationInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDesktopColorCombinationInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDigitalVibranceInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetDigitalVibranceInfoParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetDigitalVibranceInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDigitalVibranceInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDigitalVibrance: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDigitalVibranceParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDigitalVibrance',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHueInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetHueInfoParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetHueInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetHueInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHue: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetHueParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetHue',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetColorCombinationInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetColorCombinationInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetColorCombinationInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetColorAccuracyMode: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetColorAccuracyModeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetColorAccuracyMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreColorAccuracyMode: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.RestoreColorAccuracyModeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'RestoreColorAccuracyMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetColorAccuracyMode: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetColorAccuracyModeParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetColorAccuracyModeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetColorAccuracyMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetScalingSettings: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetScalingSettingsParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetScalingSettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetScalingSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetScalingSettings: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetScalingSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetScalingSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetScalingOverride: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetScalingOverrideParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetScalingOverride',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const FetchCustomTiming: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.FetchCustomTimingParameters,
    Types.Nvapp.Nvcpldisplayplugin.FetchCustomTimingReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'FetchCustomTiming',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PerformActionOnCustomResolutionLocalCache: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.PerformActionOnCustomResolutionLocalCacheParameters,
    Types.Nvapp.Nvcpldisplayplugin.PerformActionOnCustomResolutionLocalCacheReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'PerformActionOnCustomResolutionLocalCache',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetContentTypeInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetContentTypeInfoParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetContentTypeInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetContentTypeInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetContentType: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetContentTypeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetContentType',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIsUpscalingFactorsEnabled: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetIsUpscalingFactorsEnabledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetIsUpscalingFactorsEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDisplayLuid: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetDisplayLuidParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetDisplayLuidReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDisplayLuid',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreDisplayScaling: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.RestoreDisplayScalingParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'RestoreDisplayScaling',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreDisplayColorSettings: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.RestoreDisplayColorSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'RestoreDisplayColorSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIsInfoFrameEnabled: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetIsInfoFrameEnabledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetIsInfoFrameEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetScalingPreviewInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetScalingPreviewInfoParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetScalingPreviewInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetScalingPreviewInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSurroundOrMosaicConfig: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetSurroundOrMosaicConfigParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetSurroundOrMosaicConfigReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSurroundOrMosaicConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetSurroundOrMosaicConfig: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetSurroundOrMosaicConfigParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetSurroundOrMosaicConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSurroundResolution: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetSurroundResolutionReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSurroundResolution',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetSurroundResolution: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetSurroundResolutionParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetSurroundResolution',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDDSState: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetDDSStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDDSState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDDSState: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetDDSStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetDDSState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DDSBlockingAppPresent: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.DDSBlockingAppPresentReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'DDSBlockingAppPresent',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ACPowerConnected: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.ACPowerConnectedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'ACPowerConnected',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetUIState: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetUIStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetUIState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUIState: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetUIStateParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetUIStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetUIState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DisableAllMosaicGroups: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'DisableAllMosaicGroups',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDDSBlockingApps: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetDDSBlockingAppsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetDDSBlockingApps',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMosaicDisplaySettings: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetMosaicDisplaySettingsParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetMosaicDisplaySettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetMosaicDisplaySettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ExtendAllDisplays: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'ExtendAllDisplays',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSpanIdentifiers: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetSpanIdentifiersReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSpanIdentifiers',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHotkeyStates: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetHotkeyStatesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetHotkeyStates',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHotkeyStates: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetHotkeyStatesParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetHotkeyStates',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PerfCountRestrictionInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.PerfCountRestrictionInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'PerfCountRestrictionInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetIsNonAdminPerfCounterAccessAllowed: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetIsNonAdminPerfCounterAccessAllowedParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetIsNonAdminPerfCounterAccessAllowed',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSpanBezelOverlapLimits: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetSpanBezelOverlapLimitsParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetSpanBezelOverlapLimitsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSpanBezelOverlapLimits',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ShowBezelPreviewImage: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.ShowBezelPreviewImageParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'ShowBezelPreviewImage',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCustomResolutions: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetCustomResolutionsParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetCustomResolutionsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetCustomResolutions',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PerformCustomResolutionOperation: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.PerformCustomResolutionOperationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'PerformCustomResolutionOperation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DeleteCustomResolution: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.DeleteCustomResolutionParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'DeleteCustomResolution',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSelectedCustomResolution: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetSelectedCustomResolutionParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetSelectedCustomResolutionReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetSelectedCustomResolution',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CalculateCustomTiming: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.CalculateCustomTimingParameters,
    Types.Nvapp.Nvcpldisplayplugin.CalculateCustomTimingReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'CalculateCustomTiming',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SaveSelectedCustomResolution: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SaveSelectedCustomResolutionParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SaveSelectedCustomResolution',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsLegalDisclaimerAccepted: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.IsLegalDisclaimerAcceptedParameters,
    Types.Nvapp.Nvcpldisplayplugin.IsLegalDisclaimerAcceptedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'IsLegalDisclaimerAccepted',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetLegalDisclaimerAccepted: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetLegalDisclaimerAcceptedParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetLegalDisclaimerAccepted',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetEnableHiddenResolutions: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetEnableHiddenResolutionsParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetEnableHiddenResolutionsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetEnableHiddenResolutions',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetEnableHiddenResolutions: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetEnableHiddenResolutionsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetEnableHiddenResolutions',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetContextMenuVisibility: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.GetContextMenuVisibilityParameters,
    Types.Nvapp.Nvcpldisplayplugin.GetContextMenuVisibilityReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetContextMenuVisibility',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetContextMenuVisibility: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetContextMenuVisibilityParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetContextMenuVisibility',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsGpuMemoryAllocationSupported: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.IsGpuMemoryAllocationSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'IsGpuMemoryAllocationSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuMemoryAllocationInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetGpuMemoryAllocationInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetGpuMemoryAllocationInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetGpuMemoryAllocation: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetGpuMemoryAllocationParameters,
    Types.Nvapp.Nvcpldisplayplugin.SetGpuMemoryAllocationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetGpuMemoryAllocation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreGpuMemoryAllocation: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.RestoreGpuMemoryAllocationParameters,
    Types.Nvapp.Nvcpldisplayplugin.RestoreGpuMemoryAllocationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'RestoreGpuMemoryAllocation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetIntelligentCarveout: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetIntelligentCarveoutParameters,
    Types.Nvapp.Nvcpldisplayplugin.SetIntelligentCarveoutReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetIntelligentCarveout',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsGpuUtilizationPreferenceSupported: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.IsGpuUtilizationPreferenceSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'IsGpuUtilizationPreferenceSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuUtilizationPreferenceInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcpldisplayplugin.GetGpuUtilizationPreferenceInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'GetGpuUtilizationPreferenceInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetGpuUtilizationPreference: BridgeCommands.Command<
    Types.Nvapp.Nvcpldisplayplugin.SetGpuUtilizationPreferenceParameters,
    Types.Nvapp.Nvcpldisplayplugin.SetGpuUtilizationPreferenceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplDisplayPlugin',
    method: 'SetGpuUtilizationPreference',
    persistent: false
};

export const Nvcpldisplayplugin = {
GetDirect3DfeatureLevel,
GetGPUInformation,
IsECCModeSupported,
GetECCModeStatus,
SetECCModeStatus,
GetSuperResolutionInfo,
GetSuperResolutionCurrentStatus,
SetSuperResolutionValue,
GetSuperResolutionGpuUtilization,
SetSuperResolutionGpuUtilization,
GetSuperResolutionIndicatorStatus,
GetRTXVideoFlags,
SetRTXVSRFlags,
SetRTXHDRFlags,
SetSuperResolutionIndicatorStatus,
GetHDRIndicatorStatus,
SetHDRIndicatorStatus,
GetDisableVSROnGameLaunchStatus,
SetDisableVSROnGameLaunchStatus,
GetDisableHDROnGameLaunchStatus,
SetDisableHDROnGameLaunchStatus,
RestoreDefaultVideoSettings,
GetHDRInfo,
GetHDRCurrentStatus,
SetHDRValue,
SetHDRInfo,
RegisterDisplayChangeNotification,
GetGpuCount,
LaunchApplication,
IsControlPanelClientInstalled,
GetDisplaysState,
SetDisplaysState,
GetDebugModeStatus,
SetDebugModeStatus,
IsDebugModeSupported,
GetDisplayResolutionList,
GetGpuAndDisplayInformation,
GetGpuActivityInformation,
GetIGpuAndDisplayInformation,
GetGpuAndDisplaysPhysicalInformation,
RestoreDisplaySettings,
SetResolution,
SetRotation,
RevertState,
CancelState,
CommitState,
IdentifyDisplays,
GetSystemCapabilities,
GetGlobalGsyncState,
SetGlobalGsyncState,
GetGsyncIndicator,
SetGsyncIndicator,
RestoreGlobalGsyncState,
GetDisplayGsyncState,
SetDisplayGsyncState,
SetDisplayPulsarInfo,
GetDisplayAmbientAdaptiveInfo,
SetDisplayAmbientAdaptiveBrightnessInfo,
SetDisplayAmbientAdaptiveColorInfo,
GetIsColorSettingsOsControlled,
SetIsColorSettingsOsControlled,
GetColorEnhancementInfo,
GetAdvancedColorCombinationInfo,
SetAdvancedColorCombinationInfo,
SetDynamicRange,
SetOutputColorFormat,
SetDesktopColorDepth,
SetOutputColorDepth,
GetDesktopColorCombinationInfo,
GetDigitalVibranceInfo,
SetDigitalVibrance,
GetHueInfo,
SetHue,
SetColorCombinationInfo,
SetColorAccuracyMode,
RestoreColorAccuracyMode,
GetColorAccuracyMode,
GetScalingSettings,
SetScalingSettings,
SetScalingOverride,
FetchCustomTiming,
PerformActionOnCustomResolutionLocalCache,
GetContentTypeInfo,
SetContentType,
GetIsUpscalingFactorsEnabled,
GetDisplayLuid,
RestoreDisplayScaling,
RestoreDisplayColorSettings,
GetIsInfoFrameEnabled,
GetScalingPreviewInfo,
GetSurroundOrMosaicConfig,
SetSurroundOrMosaicConfig,
GetSurroundResolution,
SetSurroundResolution,
GetDDSState,
SetDDSState,
DDSBlockingAppPresent,
ACPowerConnected,
SetUIState,
GetUIState,
DisableAllMosaicGroups,
GetDDSBlockingApps,
GetMosaicDisplaySettings,
ExtendAllDisplays,
GetSpanIdentifiers,
GetHotkeyStates,
SetHotkeyStates,
PerfCountRestrictionInfo,
SetIsNonAdminPerfCounterAccessAllowed,
GetSpanBezelOverlapLimits,
ShowBezelPreviewImage,
GetCustomResolutions,
PerformCustomResolutionOperation,
DeleteCustomResolution,
GetSelectedCustomResolution,
CalculateCustomTiming,
SaveSelectedCustomResolution,
IsLegalDisclaimerAccepted,
SetLegalDisclaimerAccepted,
GetEnableHiddenResolutions,
SetEnableHiddenResolutions,
GetContextMenuVisibility,
SetContextMenuVisibility,
IsGpuMemoryAllocationSupported,
GetGpuMemoryAllocationInfo,
SetGpuMemoryAllocation,
RestoreGpuMemoryAllocation,
SetIntelligentCarveout,
IsGpuUtilizationPreferenceSupported,
GetGpuUtilizationPreferenceInfo,
SetGpuUtilizationPreference
};
